import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner({ headline = "Ready to take the next step?", sub = "Most patients are seen within a week of booking. Confidential, virtual, and tailored to your goals." }) {
 return (
 <section data-testid="cta-banner" className="container-pad max-w-7xl mx-auto py-16">
 <div className="relative overflow-hidden rounded-3xl bg-sage-700 text-white p-10 sm:p-14 lg:p-16">
 <div aria-hidden className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold-500/30 blur-3xl" />
 <div aria-hidden className="absolute -bottom-24 -left-12 w-72 h-72 rounded-full bg-sage-300/20 blur-3xl" />
 <div className="relative grid lg:grid-cols-12 gap-10 items-center">
 <div className="lg:col-span-8">
 <p className="text-xs uppercase tracking-[0.22em] text-gold-300 font-semibold">Begin care today</p>
 <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-balance">{headline}</h2>
 <p className="mt-4 text-base sm:text-lg text-cream/85 max-w-2xl">{sub}</p>
 </div>
 <div className="lg:col-span-4 flex lg:justify-end">
 <Link to="/contact" data-testid="cta-banner-book" className="btn-gold text-base">
 Book your appointment <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
 </Link>
 </div>
 </div>
 </div>
 </section>
 );
}
